// import axios from "axios";
// import { BASE_URL } from "../keys";

// export const config = {
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
// };

// const API = () => {
//   const getConfig = () => {
//     return api?.token
//       ? {
//         ...config,
//         headers: {
//           ...config.headers,
//         },
//       }
//       : config;
//   };
//   return {
//     get: (url, config = {}) => axios({ url, ...getConfig(), ...config }),
//     post: (url, data, config = {}) =>
//       axios({ url, method: "POST", data, ...getConfig(), ...config }),
//     put: (url, data, config) =>
//       axios({ url, method: "PUT", data, ...getConfig(), ...config }),
//     patch: (url, data, config) =>
//       axios({ url, method: "PATCH", data, ...getConfig(), ...config }),
//     delete: (url) => axios({ url, method: "DELETE", ...getConfig() }),
//     setToken: (token) => {
//       api.token = token;
//     },
//   };
// };

// const api = API();

// export default api;

// import axios from "axios";
// import { BASE_URL } from "../keys";
// import { notification } from "antd";

// const api = axios.create({
//   baseURL: BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });


// // ───────────── REQUEST INTERCEPTOR ─────────────
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const originalRequest = error.config;

//     const isAuthApi =
//       originalRequest.url.includes("/login") ||
//       originalRequest.url.includes("/otp") ||
//       originalRequest.url.includes("/register");

//     // If token expired → logout (no refresh token flow)
//     if (error.response?.status === 401 && !isAuthApi) {
//       localStorage.clear();

//       notification.error({
//         message: "Session expired",
//         description: "Please login again",
//       });

//       setTimeout(() => {
//         window.location.href = "/login";
//       }, 1200);
//     }

//     return Promise.reject(error);
//   }
// );


// // ───────────── RESPONSE INTERCEPTOR (REFRESH) ─────────────
// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((prom) => {
//     error ? prom.reject(error) : prom.resolve(token);
//   });
//   failedQueue = [];
// };

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     const isAuthApi =
//       originalRequest.url.includes("/login") ||
//       originalRequest.url.includes("/token/") ||
//       originalRequest.url.includes("/otp") ||
//       originalRequest.url.includes("/register");

//     // ❌ Skip interceptor for login/register/refresh APIs
//     if (error.response?.status === 401 && !originalRequest._retry && !isAuthApi) {

//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         }).then((token) => {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           return api(originalRequest);
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       const refreshToken = localStorage.getItem("refresh_token");

//       if (!refreshToken) {
//         logoutUser();
//         return Promise.reject(error);
//       }

//       try {
//         const { data } = await axios.post(
//           `${BASE_URL}api/token/refresh/`,
//           { refresh: refreshToken }
//         );

//         const newAccessToken = data.access;
//         localStorage.setItem("livtoken", newAccessToken);

//         api.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
//         processQueue(null, newAccessToken);

//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//         return api(originalRequest);

//       } catch (refreshError) {
//         processQueue(refreshError, null);
//         logoutUser();
//         return Promise.reject(refreshError);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );


// // ───────────── LOGOUT ─────────────
// function logoutUser() {
//   localStorage.clear();

//   notification.error({
//     message: "Session expired",
//     description: "Please login again",
//   });

//   setTimeout(() => {
//     window.location.href = "/login";
//   }, 1500);
// }

// export default api;
import axios from "axios";
import { BASE_URL } from "../keys";
import { notification } from "antd";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ───────────── REFRESH TOKEN LOGIC ─────────────
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    error ? prom.reject(error) : prom.resolve(token);
  });
  failedQueue = [];
};

function logoutUser() {
  localStorage.clear();

  notification.error({
    message: "Session expired",
    description: "Please login again",
  });

  setTimeout(() => {
    window.location.href = "/login";
  }, 1500);
}

// ───────────── SINGLE RESPONSE INTERCEPTOR ─────────────
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // ✅ Don't intercept auth-related APIs
    const isAuthApi =
      originalRequest.url.includes("/login") ||
      originalRequest.url.includes("/token/") ||
      originalRequest.url.includes("/otp") ||
      originalRequest.url.includes("/register");

    if (error.response?.status === 401 && !originalRequest._retry && !isAuthApi) {

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refresh_token");

      if (!refreshToken) {
        isRefreshing = false;
        logoutUser();
        return Promise.reject(error);
      }

      try {
        const { data } = await axios.post(
          `${BASE_URL}api/token/refresh/`,
          { refresh: refreshToken }
        );

        const newAccessToken = data.access;
        localStorage.setItem("livtoken", newAccessToken);

        api.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
        processQueue(null, newAccessToken);

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);

      } catch (refreshError) {
        processQueue(refreshError, null);
        logoutUser();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;